'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.currentOrganizationExecutor = currentOrganizationExecutor;
exports.fetchAccountsExecutor = fetchAccountsExecutor;
exports.uploadMediaToFBExecutor = uploadMediaToFBExecutor;
exports.getBlueprintsExecutor = getBlueprintsExecutor;
exports.deleteBlueprintExecutor = deleteBlueprintExecutor;
exports.getLayerSchemaExecutor = getLayerSchemaExecutor;
exports.postBlueprintExecutor = postBlueprintExecutor;
exports.putBlueprintExecutor = putBlueprintExecutor;
exports.postLayerTemplatesExecutor = postLayerTemplatesExecutor;
exports.getBlueprintExecutor = getBlueprintExecutor;
exports.postVariationExecutor = postVariationExecutor;
exports.postGenerateCSVExecutor = postGenerateCSVExecutor;
exports.getUserVariationExecutor = getUserVariationExecutor;
exports.postUserVariationExecutor = postUserVariationExecutor;
exports.getExportListExecutor = getExportListExecutor;
exports.putExportListExecutor = putExportListExecutor;
exports.duplicateBlueprintExecutor = duplicateBlueprintExecutor;
exports.addCustomMediaAssetExecutor = addCustomMediaAssetExecutor;
exports.exportJobFetchPollerExecutor = exportJobFetchPollerExecutor;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _effects = require('redux-saga/effects');

var _reduxSaga = require('redux-saga');

var _reactRouter = require('react-router');

var _redux = require('@adparlor-devops/js-anvil/redux');

var _antd = require('@adparlor-devops/antd');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _differenceWith = require('lodash/differenceWith');

var _differenceWith2 = _interopRequireDefault(_differenceWith);

var _generic = require('../../../helpers/generic');

var _serializers = require('../serializers');

var _constants = require('../../../constants');

var _constants2 = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(currentOrganizationExecutor),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(fetchAccountsExecutor),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(uploadMediaToFBExecutor),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(getBlueprintsExecutor),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(deleteBlueprintExecutor),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(getLayerSchemaExecutor),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(postBlueprintExecutor),
    _marked8 = /*#__PURE__*/_regenerator2.default.mark(putBlueprintExecutor),
    _marked9 = /*#__PURE__*/_regenerator2.default.mark(postLayerTemplatesExecutor),
    _marked10 = /*#__PURE__*/_regenerator2.default.mark(getBlueprintExecutor),
    _marked11 = /*#__PURE__*/_regenerator2.default.mark(postVariationExecutor),
    _marked12 = /*#__PURE__*/_regenerator2.default.mark(postGenerateCSVExecutor),
    _marked13 = /*#__PURE__*/_regenerator2.default.mark(getUserVariationExecutor),
    _marked14 = /*#__PURE__*/_regenerator2.default.mark(postUserVariationExecutor),
    _marked15 = /*#__PURE__*/_regenerator2.default.mark(getExportListExecutor),
    _marked16 = /*#__PURE__*/_regenerator2.default.mark(putExportListExecutor),
    _marked17 = /*#__PURE__*/_regenerator2.default.mark(duplicateBlueprintExecutor),
    _marked18 = /*#__PURE__*/_regenerator2.default.mark(addCustomMediaAssetExecutor),
    _marked19 = /*#__PURE__*/_regenerator2.default.mark(exportJobFetchPollerExecutor);

var cachedExportList = []; // cache used for when we're polling export lists to detect any changes

var locationIsHomePage = function locationIsHomePage() {
  return window.location.hash.endsWith("creative_at_scale") || window.location.hash.endsWith("creative_at_scale/") || window.location.hash.endsWith("creative_at_scale/create_blueprint") || window.location.hash.endsWith("creative_at_scale/create_blueprint/");
};

function currentOrganizationExecutor() {
  return _regenerator2.default.wrap(function currentOrganizationExecutor$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (locationIsHomePage()) {
            _context.next = 3;
            break;
          }

          _context.next = 3;
          return (0, _effects.call)(_reactRouter.hashHistory.push, '/creative_at_scale');

        case 3:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function fetchAccountsExecutor() {
  var session, accounts;
  return _regenerator2.default.wrap(function fetchAccountsExecutor$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 2:
          session = _context2.sent;
          _context2.prev = 3;
          _context2.next = 6;
          return (0, _effects.call)(_axios2.default.get, session.ENDPOINTS.facebook_v3_api_url + '/accounts?advertiser_id=' + session.currentAdvertiser);

        case 6:
          accounts = _context2.sent;
          _context2.next = 9;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_FETCH_ACCOUNTS_SUCCESS, payload: accounts.data });

        case 9:
          _context2.next = 15;
          break;

        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2['catch'](3);
          _context2.next = 15;
          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context2.t0 });

        case 15:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[3, 11]]);
}

var uploadToFacebook = function uploadToFacebook(session, type, request) {
  return _axios2.default.post(session.ENDPOINTS.facebook_v3_api_url + '/accounts/' + request.account_id + '/' + type, request).catch(function (error) {
    return {
      fileName: request.fileName,
      status: error.response.status,
      error: error
    };
  });
};

function uploadMediaToFBExecutor(_ref) {
  var payload = _ref.payload;
  var session, requests, type, result, failures, failMessage;
  return _regenerator2.default.wrap(function uploadMediaToFBExecutor$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 2:
          session = _context3.sent;
          _context3.prev = 3;
          _context3.next = 6;
          return (0, _effects.call)(_serializers.uploadMediaToFacebookSerializer, payload);

        case 6:
          requests = _context3.sent;
          type = payload.mediaType === "IMAGE" ? "adimages" : "advideos";
          _context3.next = 10;
          return (0, _effects.all)(requests.map(function (r) {
            return (0, _effects.call)(uploadToFacebook, session, type, r);
          }));

        case 10:
          result = _context3.sent;
          _context3.next = 13;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_UPLOAD_MEDIA_TO_FB_COMPLETE });

        case 13:
          failures = result.filter(function (res) {
            return res.status !== 201;
          });

          if (!(failures.length > 0)) {
            _context3.next = 20;
            break;
          }

          failMessage = failures.map(function (fail) {
            return _react2.default.createElement(
              'p',
              { style: { marginBottom: 10 } },
              fail.fileName
            );
          });
          _context3.next = 18;
          return (0, _effects.call)(_antd.Modal.warning, {
            title: 'The following media failed to upload to Facebook:',
            content: failMessage
          });

        case 18:
          _context3.next = 22;
          break;

        case 20:
          _context3.next = 22;
          return (0, _effects.call)(_antd.Modal.success, {
            title: 'Your media has been successfully uploaded to Facebook.'
          });

        case 22:
          _context3.next = 28;
          break;

        case 24:
          _context3.prev = 24;
          _context3.t0 = _context3['catch'](3);
          _context3.next = 28;
          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context3.t0 });

        case 28:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[3, 24]]);
}

function getBlueprintsExecutor() {
  var session, blueprints;
  return _regenerator2.default.wrap(function getBlueprintsExecutor$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          if (!locationIsHomePage()) {
            _context4.next = 16;
            break;
          }

          _context4.next = 3;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 3:
          session = _context4.sent;
          _context4.prev = 4;
          _context4.next = 7;
          return (0, _effects.call)(_axios2.default.get, session.ENDPOINTS.palette_api_url + '/blueprints?organizationId=' + session.currentAdvertiser);

        case 7:
          blueprints = _context4.sent;
          _context4.next = 10;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_GET_BLUEPRINTS_SUCCESS, payload: blueprints.data });

        case 10:
          _context4.next = 16;
          break;

        case 12:
          _context4.prev = 12;
          _context4.t0 = _context4['catch'](4);
          _context4.next = 16;
          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context4.t0 });

        case 16:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this, [[4, 12]]);
}

function deleteBlueprintExecutor(_ref2) {
  var payload = _ref2.payload;
  var session;
  return _regenerator2.default.wrap(function deleteBlueprintExecutor$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 2:
          session = _context5.sent;
          _context5.prev = 3;
          _context5.next = 6;
          return (0, _effects.call)(_axios2.default.delete, session.ENDPOINTS.palette_api_url + '/blueprints/' + payload.id);

        case 6:
          _context5.next = 8;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_DELETE_BLUEPRINT_SUCCESS, payload: { id: payload.id } });

        case 8:
          _context5.next = 14;
          break;

        case 10:
          _context5.prev = 10;
          _context5.t0 = _context5['catch'](3);
          _context5.next = 14;
          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context5.t0 });

        case 14:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this, [[3, 10]]);
}

function getLayerSchemaExecutor() {
  var session, layerSchema;
  return _regenerator2.default.wrap(function getLayerSchemaExecutor$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 2:
          session = _context6.sent;
          _context6.prev = 3;
          _context6.next = 6;
          return (0, _effects.call)(_axios2.default.get, session.ENDPOINTS.palette_api_url + '/layer-schema');

        case 6:
          layerSchema = _context6.sent;
          _context6.next = 9;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_GET_LAYER_SCHEMA_SUCCESS, payload: layerSchema.data });

        case 9:
          _context6.next = 15;
          break;

        case 11:
          _context6.prev = 11;
          _context6.t0 = _context6['catch'](3);
          _context6.next = 15;
          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context6.t0 });

        case 15:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this, [[3, 11]]);
}

function postBlueprintExecutor(_ref3) {
  var payload = _ref3.payload;
  var session, data, blueprint;
  return _regenerator2.default.wrap(function postBlueprintExecutor$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 2:
          session = _context7.sent;
          _context7.prev = 3;
          _context7.next = 6;
          return (0, _effects.call)(_serializers.postBlueprintSerializer, payload);

        case 6:
          data = _context7.sent;
          _context7.next = 9;
          return (0, _effects.call)(_axios2.default.post, session.ENDPOINTS.palette_api_url + '/blueprints', data);

        case 9:
          blueprint = _context7.sent;
          _context7.next = 12;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_BLUEPRINT_SUCCESS, payload: blueprint.data });

        case 12:
          _context7.next = 14;
          return (0, _effects.call)(_reactRouter.hashHistory.push, '/creative_at_scale/create_blueprint/' + blueprint.data.data.id);

        case 14:
          _context7.next = 20;
          break;

        case 16:
          _context7.prev = 16;
          _context7.t0 = _context7['catch'](3);
          _context7.next = 20;
          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context7.t0 });

        case 20:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this, [[3, 16]]);
}

function putBlueprintExecutor(_ref4) {
  var payload = _ref4.payload;
  var session, data, blueprint;
  return _regenerator2.default.wrap(function putBlueprintExecutor$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 2:
          session = _context8.sent;
          _context8.prev = 3;
          _context8.next = 6;
          return (0, _effects.call)(_serializers.putBlueprintSerializer, payload);

        case 6:
          data = _context8.sent;
          _context8.next = 9;
          return (0, _effects.call)(_axios2.default.put, session.ENDPOINTS.palette_api_url + '/blueprints/' + data.id + '/details', data);

        case 9:
          blueprint = _context8.sent;
          _context8.next = 12;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_PUT_BLUEPRINT_SUCCESS, payload: blueprint.data });

        case 12:
          _context8.next = 20;
          break;

        case 14:
          _context8.prev = 14;
          _context8.t0 = _context8['catch'](3);
          _context8.next = 18;
          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context8.t0 });

        case 18:
          _context8.next = 20;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_PUT_BLUEPRINT_FAILED });

        case 20:
        case 'end':
          return _context8.stop();
      }
    }
  }, _marked8, this, [[3, 14]]);
}

function postLayerTemplatesExecutor(_ref5) {
  var payload = _ref5.payload;

  var session, currentBlueprint, successText, data, _data, _data2;

  return _regenerator2.default.wrap(function postLayerTemplatesExecutor$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 2:
          session = _context9.sent;
          _context9.next = 5;
          return (0, _effects.select)(function (state) {
            return state[_constants.STORE_NAMESPACE].blueprints.blueprint;
          });

        case 5:
          currentBlueprint = _context9.sent;
          successText = 'Congratulations! You have successfully created your blueprint.';
          _context9.prev = 7;

          if (!(window.location.hash.includes('isDuplicate=true') && currentBlueprint.layerTemplates.length !== 0)) {
            _context9.next = 22;
            break;
          }

          _context9.t0 = _extends3.default;
          _context9.t1 = {};
          _context9.t2 = currentBlueprint;
          _context9.t3 = {
            name: payload.blueprintName
          };
          _context9.next = 15;
          return (0, _effects.call)(_serializers.postLayerTemplatesSerializer, payload.layerTemplates);

        case 15:
          _context9.t4 = _context9.sent;
          data = (0, _context9.t0)(_context9.t1, _context9.t2, _context9.t3, _context9.t4);

          successText = 'Congratulations! You have successfully duplicated your blueprint.';
          _context9.next = 20;
          return (0, _effects.call)(_axios2.default.put, session.ENDPOINTS.palette_api_url + '/blueprints/' + currentBlueprint.id + '/details?forceLayersUpdate=true', data);

        case 20:
          _context9.next = 42;
          break;

        case 22:
          if (!(currentBlueprint.layerTemplates.length !== 0)) {
            _context9.next = 37;
            break;
          }

          _context9.t5 = _extends3.default;
          _context9.t6 = {};
          _context9.t7 = currentBlueprint;
          _context9.t8 = payload.blueprintName;
          _context9.next = 29;
          return (0, _effects.call)(_serializers.updateLayerTemplatesTooltipSerializer, currentBlueprint.layerTemplates, payload.layerTemplates);

        case 29:
          _context9.t9 = _context9.sent;
          _context9.t10 = {
            name: _context9.t8,
            layerTemplates: _context9.t9
          };
          _data = (0, _context9.t5)(_context9.t6, _context9.t7, _context9.t10);

          successText = 'Blueprint Updated.';
          _context9.next = 35;
          return (0, _effects.call)(_axios2.default.put, session.ENDPOINTS.palette_api_url + '/blueprints/' + currentBlueprint.id + '/details?forceLayersUpdate=false', _data);

        case 35:
          _context9.next = 42;
          break;

        case 37:
          _context9.next = 39;
          return (0, _effects.call)(_serializers.postLayerTemplatesSerializer, payload.layerTemplates);

        case 39:
          _data2 = _context9.sent;
          _context9.next = 42;
          return (0, _effects.call)(_axios2.default.post, session.ENDPOINTS.palette_api_url + '/blueprints/' + currentBlueprint.id + '/layer-templates', _data2);

        case 42:
          _context9.next = 44;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_LAYER_TEMPLATES_SUCCESS });

        case 44:
          _context9.next = 46;
          return (0, _effects.call)(_antd.Modal.success, {
            title: successText
          });

        case 46:
          _context9.next = 48;
          return (0, _effects.call)(_reactRouter.hashHistory.push, '/creative_at_scale/create_blueprint');

        case 48:
          _context9.next = 56;
          break;

        case 50:
          _context9.prev = 50;
          _context9.t11 = _context9['catch'](7);
          _context9.next = 54;
          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context9.t11 });

        case 54:
          _context9.next = 56;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_LAYER_TEMPLATES_FAILED });

        case 56:
        case 'end':
          return _context9.stop();
      }
    }
  }, _marked9, this, [[7, 50]]);
}

function getBlueprintExecutor(_ref6) {
  var payload = _ref6.payload;
  var session, blueprint;
  return _regenerator2.default.wrap(function getBlueprintExecutor$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 2:
          session = _context10.sent;
          _context10.prev = 3;
          _context10.next = 6;
          return (0, _effects.call)(_axios2.default.get, session.ENDPOINTS.palette_api_url + '/blueprints/' + payload.id + '/details');

        case 6:
          blueprint = _context10.sent;
          _context10.next = 9;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_GET_BLUEPRINT_SUCCESS, payload: blueprint.data });

        case 9:
          _context10.next = 15;
          break;

        case 11:
          _context10.prev = 11;
          _context10.t0 = _context10['catch'](3);
          _context10.next = 15;
          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context10.t0 });

        case 15:
        case 'end':
          return _context10.stop();
      }
    }
  }, _marked10, this, [[3, 11]]);
}

function postVariationExecutor(_ref7) {
  var payload = _ref7.payload;
  var session, data;
  return _regenerator2.default.wrap(function postVariationExecutor$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 2:
          session = _context11.sent;
          _context11.prev = 3;
          _context11.next = 6;
          return (0, _effects.call)(_serializers.postVariationSerializer, payload);

        case 6:
          data = _context11.sent;
          _context11.next = 9;
          return (0, _effects.call)(_axios2.default.post, session.ENDPOINTS.palette_api_url + '/generate-variations', data);

        case 9:
          _context11.next = 11;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_VARIATION_SUCCESS });

        case 11:
          _context11.next = 13;
          return (0, _effects.call)(_reactRouter.hashHistory.push, '/creative_at_scale');

        case 13:
          _context11.next = 15;
          return (0, _effects.call)(_antd.Modal.success, {
            title: 'Congratulations! You have successfully created your variation.',
            content: 'Your variation will be emailed to you within 24 hours.'
          });

        case 15:
          _context11.next = 23;
          break;

        case 17:
          _context11.prev = 17;
          _context11.t0 = _context11['catch'](3);
          _context11.next = 21;
          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context11.t0 });

        case 21:
          _context11.next = 23;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_VARIATION_FAILED });

        case 23:
        case 'end':
          return _context11.stop();
      }
    }
  }, _marked11, this, [[3, 17]]);
}

function postGenerateCSVExecutor(_ref8) {
  var payload = _ref8.payload;
  var session, blueprint, data;
  return _regenerator2.default.wrap(function postGenerateCSVExecutor$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 2:
          session = _context12.sent;
          _context12.next = 5;
          return (0, _effects.select)(function (state) {
            return state[_constants.STORE_NAMESPACE].blueprints.blueprint;
          });

        case 5:
          blueprint = _context12.sent;
          _context12.prev = 6;
          _context12.next = 9;
          return (0, _effects.call)(_serializers.postGenerateCSVSerializer, payload);

        case 9:
          data = _context12.sent;
          _context12.next = 12;
          return (0, _effects.call)(_axios2.default.post, session.ENDPOINTS.palette_api_url + '/generate-csv', data);

        case 12:
          _context12.next = 14;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_GENERATE_CSV_COMPLETE });

        case 14:
          _context12.next = 16;
          return (0, _effects.call)(_antd.notification.success, {
            message: "Success",
            description: session.ENDPOINTS.palette_api_url + '/blueprints/' + blueprint.id + '/json-feed',
            style: {
              wordWrap: "break-word"
            }
          });

        case 16:
          _context12.next = 24;
          break;

        case 18:
          _context12.prev = 18;
          _context12.t0 = _context12['catch'](6);
          _context12.next = 22;
          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context12.t0 });

        case 22:
          _context12.next = 24;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_GENERATE_CSV_COMPLETE });

        case 24:
        case 'end':
          return _context12.stop();
      }
    }
  }, _marked12, this, [[6, 18]]);
}

function getUserVariationExecutor(_ref9) {
  var payload = _ref9.payload;
  var session, userId, blueprintId, userVariation;
  return _regenerator2.default.wrap(function getUserVariationExecutor$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 2:
          session = _context13.sent;
          _context13.prev = 3;
          userId = session.user.id;
          blueprintId = payload.blueprintId;
          _context13.next = 8;
          return (0, _effects.call)(_axios2.default.get, session.ENDPOINTS.palette_api_url + '/users/' + userId + '/blueprint/' + blueprintId + '/user-variations');

        case 8:
          userVariation = _context13.sent;
          _context13.next = 11;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_GET_USER_VARIATION_SUCCESS, payload: userVariation.data });

        case 11:
          _context13.next = 17;
          break;

        case 13:
          _context13.prev = 13;
          _context13.t0 = _context13['catch'](3);
          _context13.next = 17;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_GET_USER_VARIATION_FAILED });

        case 17:
        case 'end':
          return _context13.stop();
      }
    }
  }, _marked13, this, [[3, 13]]);
}

function postUserVariationExecutor(_ref10) {
  var payload = _ref10.payload;
  var session, data;
  return _regenerator2.default.wrap(function postUserVariationExecutor$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 2:
          session = _context14.sent;
          _context14.prev = 3;
          _context14.next = 6;
          return (0, _effects.call)(_serializers.postUserVariationSerializer, payload);

        case 6:
          data = _context14.sent;
          _context14.next = 9;
          return (0, _effects.call)(_axios2.default.post, session.ENDPOINTS.palette_api_url + '/user-variations', data);

        case 9:
          _context14.next = 11;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_USER_VARIATION_SUCCESS });

        case 11:
          _context14.next = 17;
          break;

        case 13:
          _context14.prev = 13;
          _context14.t0 = _context14['catch'](3);
          _context14.next = 17;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_POST_USER_VARIATION_FAILED });

        case 17:
        case 'end':
          return _context14.stop();
      }
    }
  }, _marked14, this, [[3, 13]]);
}

function getExportListExecutor(_ref11) {
  var payload = _ref11.payload;
  var params, session, exportList;
  return _regenerator2.default.wrap(function getExportListExecutor$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          if (!window.location.hash.includes("progress")) {
            _context15.next = 17;
            break;
          }

          // Need to make sure we're on the right route before we fetch
          params = (0, _generic.getDateRange)(payload);
          _context15.next = 4;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 4:
          session = _context15.sent;
          _context15.prev = 5;
          _context15.next = 8;
          return (0, _effects.call)(_axios2.default.get, session.ENDPOINTS.palette_api_url + '/export-jobs?organizationId=' + session.currentAdvertiser, { params: params });

        case 8:
          exportList = _context15.sent;
          _context15.next = 11;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_GET_EXPORT_LIST_SUCCESS, payload: exportList.data });

        case 11:
          _context15.next = 17;
          break;

        case 13:
          _context15.prev = 13;
          _context15.t0 = _context15['catch'](5);
          _context15.next = 17;
          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context15.t0 });

        case 17:
        case 'end':
          return _context15.stop();
      }
    }
  }, _marked15, this, [[5, 13]]);
}

function putExportListExecutor(_ref12) {
  var payload = _ref12.payload;
  var session, data, exportList;
  return _regenerator2.default.wrap(function putExportListExecutor$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          if (!payload.updateBackend) {
            _context16.next = 17;
            break;
          }

          _context16.next = 3;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 3:
          session = _context16.sent;
          _context16.prev = 4;
          data = { status: "IN_PROGRESS" };
          _context16.next = 8;
          return (0, _effects.call)(_axios2.default.put, session.ENDPOINTS.palette_api_url + '/export-jobs/' + payload.data.id, data);

        case 8:
          exportList = _context16.sent;
          _context16.next = 11;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_PUT_EXPORT_LIST_SUCCESS, payload: { data: exportList.data.data, updateBackend: false } });

        case 11:
          _context16.next = 17;
          break;

        case 13:
          _context16.prev = 13;
          _context16.t0 = _context16['catch'](4);
          _context16.next = 17;
          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context16.t0 });

        case 17:
        case 'end':
          return _context16.stop();
      }
    }
  }, _marked16, this, [[4, 13]]);
}

function duplicateBlueprintExecutor(_ref13) {
  var payload = _ref13.payload;
  var session, userId, duplicate;
  return _regenerator2.default.wrap(function duplicateBlueprintExecutor$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _context17.next = 2;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 2:
          session = _context17.sent;
          _context17.prev = 3;
          userId = session.user.id;
          _context17.next = 7;
          return (0, _effects.call)(_axios2.default.post, session.ENDPOINTS.palette_api_url + '/blueprints/' + payload.id + '/duplicate', { createdBy: userId });

        case 7:
          duplicate = _context17.sent;
          _context17.next = 10;
          return (0, _effects.call)(_reactRouter.hashHistory.push, '/creative_at_scale/create_blueprint/' + duplicate.data.data.id + '?isDuplicate=true');

        case 10:
          _context17.next = 12;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_DUPLICATE_BLUEPRINT_SUCCESS });

        case 12:
          _context17.next = 18;
          break;

        case 14:
          _context17.prev = 14;
          _context17.t0 = _context17['catch'](3);
          _context17.next = 18;
          return (0, _effects.put)({ type: _redux.NOTIFICATION_BUS_ERROR, payload: _context17.t0 });

        case 18:
        case 'end':
          return _context17.stop();
      }
    }
  }, _marked17, this, [[3, 14]]);
}

function addCustomMediaAssetExecutor(_ref14) {
  var _layer$validators$fin;

  var payload = _ref14.payload;
  var session, blueprint, currentBlueprint, layer, addedImages, updatedBlueprint;
  return _regenerator2.default.wrap(function addCustomMediaAssetExecutor$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _effects.select)(function (state) {
            return state.session;
          });

        case 2:
          session = _context18.sent;
          _context18.next = 5;
          return (0, _effects.select)(function (state) {
            return state[_constants.STORE_NAMESPACE].blueprints.blueprint;
          });

        case 5:
          blueprint = _context18.sent;
          currentBlueprint = (0, _cloneDeep2.default)(blueprint);
          layer = currentBlueprint.layerTemplates.find(function (layer) {
            return layer.id === payload.layerId;
          });
          addedImages = payload.fileList.map(function (file) {
            return file.response.data;
          });

          (_layer$validators$fin = layer.validators.find(function (item) {
            return item.type === "SUPPORTED_ITEM_VALIDATOR";
          }).args).push.apply(_layer$validators$fin, (0, _toConsumableArray3.default)(addedImages));
          _context18.next = 12;
          return (0, _effects.call)(_axios2.default.put, session.ENDPOINTS.palette_api_url + '/blueprints/' + currentBlueprint.id + '/details?forceLayersUpdate=true', currentBlueprint);

        case 12:
          updatedBlueprint = _context18.sent;
          _context18.next = 15;
          return (0, _effects.put)({ type: _constants2.MS_PAINT_GET_BLUEPRINT_SUCCESS, payload: updatedBlueprint.data });

        case 15:
          _context18.next = 17;
          return (0, _effects.call)(_antd.message.destroy);

        case 17:
          _context18.next = 19;
          return (0, _effects.call)(_antd.message.success, 'Success!');

        case 19:
        case 'end':
          return _context18.stop();
      }
    }
  }, _marked18, this);
}

function exportJobFetchPollerExecutor(_ref15) {
  var _this = this;

  var payload = _ref15.payload;

  var _loop;

  return _regenerator2.default.wrap(function exportJobFetchPollerExecutor$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _loop = /*#__PURE__*/_regenerator2.default.mark(function _loop() {
            var session, exportListRes, exportList, exportJobDifferenceList, checkExportJobCompleted, params, _exportList;

            return _regenerator2.default.wrap(function _loop$(_context20) {
              while (1) {
                switch (_context20.prev = _context20.next) {
                  case 0:
                    _context20.next = 2;
                    return (0, _effects.select)(function (state) {
                      return state.session;
                    });

                  case 2:
                    session = _context20.sent;
                    _context20.prev = 3;
                    _context20.next = 6;
                    return (0, _effects.call)(_axios2.default.get, session.ENDPOINTS.palette_api_url + '/export-jobs?organizationId=' + session.currentAdvertiser);

                  case 6:
                    exportListRes = _context20.sent;
                    exportList = exportListRes.data.data;

                    if (!(cachedExportList.length === 0)) {
                      _context20.next = 12;
                      break;
                    }

                    cachedExportList = exportList;
                    _context20.next = 25;
                    break;

                  case 12:
                    exportJobDifferenceList = (0, _differenceWith2.default)(exportList, cachedExportList, _isEqual2.default);

                    if (!exportJobDifferenceList.length) {
                      _context20.next = 24;
                      break;
                    }

                    checkExportJobCompleted = /*#__PURE__*/_regenerator2.default.mark(function checkExportJobCompleted(exportJob) {
                      var findJobCompleted, completedJob, checkUser, dateCreated, blueprintName, assetUrl;
                      return _regenerator2.default.wrap(function checkExportJobCompleted$(_context19) {
                        while (1) {
                          switch (_context19.prev = _context19.next) {
                            case 0:
                              findJobCompleted = exportList.filter(function (ej) {
                                return ej.status === 'COMPLETED' && ej.id === exportJob.id;
                              });
                              completedJob = findJobCompleted.length > 0 ? findJobCompleted[0] : null;
                              checkUser = session.user.email === exportJob.userEmail;

                              if (!(['QUEUED', 'IN_PROGRESS'].includes(exportJob.status) && completedJob && checkUser)) {
                                _context19.next = 9;
                                break;
                              }

                              dateCreated = (0, _generic.formatDateToHumanReadable)(completedJob.createdAt) || '{dateCreated}';
                              blueprintName = completedJob.blueprintName || '{blueprintName}';
                              assetUrl = completedJob.assetLink || '';
                              _context19.next = 9;
                              return (0, _effects.call)(_antd.notification.success, {
                                message: "Creative Blueprints",
                                description: _react2.default.createElement(
                                  'div',
                                  null,
                                  _react2.default.createElement(
                                    'div',
                                    null,
                                    'Your Export Job requested at ',
                                    _react2.default.createElement(
                                      'strong',
                                      null,
                                      dateCreated
                                    ),
                                    ' for ',
                                    _react2.default.createElement(
                                      'strong',
                                      null,
                                      blueprintName
                                    ),
                                    ' has completed!'
                                  ),
                                  _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(
                                      'a',
                                      { href: assetUrl },
                                      'Click here to download'
                                    )
                                  )
                                ),
                                duration: 0,
                                style: {
                                  wordWrap: "break-word",
                                  fontFamily: "Helvetica Neue"
                                }
                              });

                            case 9:
                            case 'end':
                              return _context19.stop();
                          }
                        }
                      }, checkExportJobCompleted, this);
                    });
                    _context20.next = 17;
                    return (0, _effects.all)(cachedExportList.map(function (exportJob) {
                      return (0, _effects.call)(checkExportJobCompleted, exportJob);
                    }));

                  case 17:
                    if (!(payload && payload.dateRange)) {
                      _context20.next = 24;
                      break;
                    }

                    params = (0, _generic.getDateRange)(payload);
                    _context20.next = 21;
                    return (0, _effects.call)(_axios2.default.get, session.ENDPOINTS.palette_api_url + '/export-jobs?organizationId=' + session.currentAdvertiser, { params: params });

                  case 21:
                    _exportList = _context20.sent;
                    _context20.next = 24;
                    return (0, _effects.put)({ type: _constants2.MS_PAINT_GET_EXPORT_LIST_SUCCESS, payload: _exportList.data });

                  case 24:

                    cachedExportList = exportList;

                  case 25:
                    _context20.next = 29;
                    break;

                  case 27:
                    _context20.prev = 27;
                    _context20.t0 = _context20['catch'](3);

                  case 29:
                    _context20.next = 31;
                    return (0, _reduxSaga.delay)(_constants.EXPORT_JOBS_POLLING_DELAY);

                  case 31:
                  case 'end':
                    return _context20.stop();
                }
              }
            }, _loop, _this, [[3, 27]]);
          });

        case 1:
          if (!true) {
            _context21.next = 5;
            break;
          }

          return _context21.delegateYield(_loop(), 't0', 3);

        case 3:
          _context21.next = 1;
          break;

        case 5:
        case 'end':
          return _context21.stop();
      }
    }
  }, _marked19, this);
}


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/ms-paint/lib/store/blueprint/sagas/executors.js
// module id = 3920
// module chunks = 5 6 7 8